import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Switch } from "../ui/switch";
import { Shield, Moon, Sun } from "lucide-react";

export function RoleSettings({ user, t }) {
  return (
    <Card className="bento-card" data-testid="role-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Shield className="w-5 h-5" />{t("settings.rolePermissions")}</CardTitle>
        <CardDescription>{t("settings.accessLevel")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="p-4 rounded-lg bg-muted/50 border">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-medium">{t("settings.currentRole")}:</span>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary capitalize">{user?.role?.replace("_", " ")}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function AppearanceSettings({ theme, toggleTheme, t }) {
  return (
    <Card className="bento-card" data-testid="appearance-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">{theme === "dark" ? <Moon className="w-5 h-5" /> : <Sun className="w-5 h-5" />}{t("settings.appearance")}</CardTitle>
        <CardDescription>{t("settings.customizeAppearance")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">{t("settings.darkMode")}</p>
            <p className="text-sm text-muted-foreground">{t("settings.darkModeDesc")}</p>
          </div>
          <Switch checked={theme === "dark"} onCheckedChange={toggleTheme} data-testid="settings-theme-switch" />
        </div>
      </CardContent>
    </Card>
  );
}

export function AccountInfoSettings({ user, t }) {
  return (
    <Card className="bento-card" data-testid="account-info-card">
      <CardHeader>
        <CardTitle>{t("settings.accountInfo")}</CardTitle>
        <CardDescription>{t("settings.accountDetails")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">{t("settings.userId")}</span>
            <code className="text-xs bg-muted px-2 py-1 rounded">{user?.user_id}</code>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">{t("settings.accountType")}</span>
            <span>{user?.password ? t("settings.emailPassword") : t("settings.googleOAuth")}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
